import React from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const MultiSelect = (props) => {
  const {
    label,
    onChange,
    menuList,
    name,
    isMulti,
    value,
    error,
    placeholder,
    className,
  } = props;
  const style = {
    control: (base) => ({
      ...base,
      border: 0,
      marginTop: "5px",
      boxShadow: "none",
    }),
  };
  return (
    <>
      <div className="custom-multi-select">
        <label className="label">{label}</label>
        <Select
          options={menuList}
          isMulti={isMulti}
          components={{
            IndicatorSeparator: () => null,
          }}
          name={name}
          onChange={onChange}
          styles={style}
          value={value}
          className = {className ? className : 'multi-select'}
          placeholder={placeholder ? placeholder : "Select"}
        />
      </div>
      {error !== undefined &&
        error !== null &&
        Object.keys(error).length > 0 && (
          <p
            style={{
              fontSize: "10px",
              color: "red",
              margin: 0,
            }}
          >
            {String(error[name])}
          </p>
        )}
    </>
  );
};

export default MultiSelect;
